<template>
  <!--<div class="product-header">
    <div class="product-preview">
      <div class="shop-breadcrumb">
        <router-link class="breadcrumb--link" :to="getRouteToHome()">Home</router-link>
      </div>
    </div>
  </div>-->
  <div class="accessdenied">
    <p>
      <span class="site-accessdenied">{{$t("shop_access_denied")}}</span>
      <div v-if="showLogin">
        <span class="not-exist">{{$t("shop_pw_needed")}}</span>
      </div>
      <div v-else>
        <span class="not-exist">{{$t("shop_access_denied_des")}}</span>
      </div>
    </p>
    <div v-if="showLogin">
      <ul class="km__list--modules shop--login">
        <li class="km__list__element">
          <input class="km__input--standard" type="password" :placeholder="$t('konf_Passwort')" v-model="password">
        </li>
        <li class="km__list__element">
          <button class="km__button--standard login" @click="login">{{ $t("konf_Anmelden") }}</button>
        </li>
      </ul>
    </div>
    <div v-if="loginFailed">
      <span class="error">{{$t("shop_loginFailed")}}</span>
    </div>
  </div>

</template>

<script>

import {setHeadTags} from "~/metatags/metatags.ts";
import {useShopInfos} from "~/store/shopInfosStore.ts";
import {useShopSeiten} from "~/store/shopSeitenStore.ts";

export default {
  name: "AccessDenied",
  props: {
    showLogin: {
      type: Boolean,
      required: true,
    }
  },
  setup(){
    const shopInfos = useShopInfos();
    const shopseite = useShopSeiten();
    const url = useRequestURL();

    const password = ref("");

    setHeadTags(shopInfos.getShopSprache, shopInfos.getShopLand, shopInfos.shopname, shopseite.getProduktSeite?.BeschreibungContent || "", shopInfos.shoplogopath, null, url.toString(), false);

    function login(){
      shopInfos.loginToShop(password.value);
    }

    return {
      password,
      login,
      loginFailed:computed(() => shopInfos.getLoginToShopFailed)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-header {
  display: flex;
  flex-direction: row;
  padding-bottom: 60px;
  position: relative;

  .product-preview {
    width: 65%;
    position: relative;

    @media (max-width: 940px) {
      width: 50%;
    }
  }

  @media (max-width: 740px) {
    flex-direction: column;

    .product-preview {
      width: 100%;
    }
  }
}

.accessdenied {
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .site-accessdenied {
    display: block;
    font-size: 72px;
    line-height: 74px;
    font-weight: 700;
    margin-bottom: 24px;
  }

  .not-exist {
    display: block;
  }
}

.km__list--modules {
  &.shop--login {
    .km__list__element {
      display: block;
      margin-bottom: 12px;
      position: relative;

      &:nth-child(1) {
        padding-top: 10px;
      }

      &:nth-child(3) {
        margin-bottom: 35px;
      }
    }
  }
}

.km__button--standard {
  &.login {
    margin: 30px auto 55px auto;
  }
}

.error {
  font-size: 13px;
  margin-bottom: 5px;
  font-weight: 500;
  color: red;
  display: block;
  padding-top: 3px;
}
</style>
